import { startInstance } from '../api/endpoints'
import type { StartInstanceRequest } from '@expostreamer/shared-types'

interface StartCaptureProps {
  processName: string
  fileName?: string
  duration?: number | string
  stopOnFinish?: boolean
  onSuccess?: () => void
  onFinish?: () => void
  onError?: () => void
}

function startCapture({
  processName,
  fileName,
  duration = undefined,
  stopOnFinish = false,
  onSuccess = () => {},
  onFinish = () => {},
  onError = () => {},
}: StartCaptureProps): void {
  if (!fileName) return

  // NOTE: this body shape (instanceName/duration/processName/stopOnFinish) does
  // not match what /admin/instance/start actually reads (instancePreset/
  // folderName/fileName/url/timestamp — see StartInstanceRequest). Typing this
  // call surfaced that mismatch; preserved as-is rather than guessing a fix.
  startInstance({
    instanceName: processName,
    fileName,
    duration,
    processName,
    stopOnFinish,
  } as unknown as StartInstanceRequest).then(({ ok, status }) => {
    if (ok) {
      onSuccess()
    } else {
      if (status === 404) {
        window.location.href = './login'
      }
    }
  })
}

export { startCapture }
